import React from 'react'

export interface CopyBranding {
  PictogramsDescription: string | null
  ProSeriesRangeDisplayName: string
}

const ApplicationName = 'Switch & Socket Builder'

export const CopyGeneric = {
  SelectorScreen: {
    ButtonCustomiseSwitches: 'Customise Switches',
    MenuType: 'Type',
    MenuButtons: 'Switches',
    MenuSockets: 'Sockets',
    MenuExtraSwitches: 'Extra Switches',
    MenuStyle: 'Style',
  },

  ButtonAddToMyList: 'Add to my list',
  ButtonDownload: 'Download your List',
  ButtonDownloadElectrician: 'Download your List / BOM',
  ButtonAddToCashSalesCart: 'Add List to Cart',

  WiserExtraInformation: (
    <>
      Start with a simple in-room app control from your phone using BLE (Bluetooth Low Energy), or control your home from anywhere, via app, voice, moments (scenes) or automations using Zigbee switches and Wiser Hub.
    </>),
  CbusExtraInformation: (
    <>
      C-Bus is a fully bespoke professional wired home automation system.
    </>),

  DefaultListName: 'My List',

  ApplicationName,

  Wholesaler: {
    ClosePopup: {
      Title: `Close the ${ApplicationName}?`,
      Body: `Note: If you close the ${ApplicationName} all progress will be lost.`,
      ConfirmButton: 'Close builder',
      CancelButton: 'Keep building',
    },
    AddToCartButton: 'Move items to cart',
    AddToCartPopup: {
      Title: 'Anything else to add?',
      Body: `Note: The ${ApplicationName} will close after your items are moved to your Wholesaler’s cart.`,
      ConfirmButton: 'Move to cart',
      CancelButton: 'Cancel',
    },
    AddToCartLoading: 'Moving items to cart…',
    AddToCartSuccessPopup: {
      Title: 'Success!',
      Body: 'Your items were moved to the cart.',
      CartButton: 'Open cart',
    },
    AddToCartFailedPopup: {
      Title: 'Something went wrong!',
      Body: 'We couldn\'t add your items to the cart.',
      TryAgainButton: 'Try again',
    },
  },

  Clipspec: {
    ImageErrorPopup: {
      Title: (count: number): string => {
        if (count === 1) { return `${count} image failed to load!` }
        return `${count} images failed to load!`
      },
      Body_ConsultationFlow: 'You can still add these products to your Clipspec Plan but some images won’t be included',
      Body_ProductFlow:      'You can still add these products to your Clipspec Product Set but some images won’t be included',
      BackButton: 'Back',
      ContinueButton: 'Continue',
    },
    ConnectionErrorPopup: {
      Title: 'Something went wrong!',
      Subtitle: 'Clipspec could not connect to the Iconic Builder',
      ErrorCode: 'Error code:',
      Body: (
        <>
          <span>Report this error to the </span>
          <a
            href="https://schneider-electric-au.atlassian.net/servicedesk/customer/portal/2"
            target="_blank"
            rel="noreferrer"
          >
            Jira Help Desk
          </a>
          <span> and try again later</span>
        </>
      ),
    },
  },
}